// tenantRoleLimits:roleSlug~min~max[,roleSlug~min~max...]   (empty max = no limit)
// for the tenant_role_matrix input (FormulateTenantRoleMatrix) - its value is { role_slug: [tu_id, ...] }
// passes when every listed role has at least min (and at most max) contacts selected
// the backend (TenantRoleMatrixInput) builds the args and enforces the same limits again on save
// NOTE: rule names must be camelCase (no underscores) - see js/formulate-config.js
const parseLimits = (args) => args.map((arg) => {
  const [slug, min, max] = String(arg).split('~');
  return {
    slug,
    min: Number(min) || 0,
    max: (max === undefined || max === '') ? null : Number(max),
  };
});

const countSelected = (value, slug) => ((value && Array.isArray(value[slug])) ? value[slug].length : 0);

const tenantRoleLimits = ({ value }, ...args) => parseLimits(args).every(({ slug, min, max }) => {
  const count = countSelected(value, slug);
  return count >= min && (max === null || count <= max);
});

// the matrix component highlights exactly which columns are short/over, so the message stays general
const tenantRoleLimitsMessage = () => 'Please select the required number of contacts for each contact type (see the counts at the bottom of each column).';

export default {
  rules: { tenantRoleLimits },
  messages: {
    tenantRoleLimits: tenantRoleLimitsMessage,
  },
};
